var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _rect, _line, _rect2, _line2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyle601(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-204,.cls-203,.cls-201{fill:#fff;}.cls-204,.cls-203,.cls-202,.cls-201{stroke:#000;stroke-miterlimit:10;}.cls-204{stroke-width:3px;}.cls-202{fill:none;}.cls-201{stroke-width:1.98px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M167,68.45a10.59,10.59,0,0,0-1.19,5c.2,9.6,15.13,18.82,36.67,23.78.19,4.56.69,10.11.89,14.67-2.85-.78-25.42-.36-35.17-12.69-1.75-2.21-5.25-4.88-7.56-8.58-1.16-1.87-4.69-4.77-4.39-9,.33-4.48,4.35-8,5.42-9.26A18.85,18.85,0,0,1,167,68.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M95.52,417.35l61.58,4.08a38.9,38.9,0,0,0,39.43-26.52c7.1-21.19,11.83-40.77,14.05-63.32,7.06-71.4-.53-147.62-1.42-219.45-4.32.47-23.4,2.08-39.57-11.1a51,51,0,0,1-14.51-19.31l-44.86,23.79-2,1.08h-.06l-.27.14v1.67c.62,1.76,1.2,3.57,1.72,5.42,8.68,30.12,7.16,70.74.81,75.71a17.56,17.56,0,0,1-7.45,3.67,42,42,0,0,1-5.25.76h-.26l-1.39.12c.59,2.23,1.15,4.49,1.66,6.79q1.86,8.37,3.15,17.37c2.48,17.22,3.59,36.29,4.36,57.52C107.34,335.58,104.69,383,95.52,417.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M242.05,68.45a10.59,10.59,0,0,1,1.19,5C243,83,228.1,92.23,206.57,97.19c-.19,4.56-.69,10.11-.89,14.67,2.85-.78,25.42-.36,35.17-12.69,1.75-2.21,5.25-4.88,7.55-8.58,1.17-1.87,4.7-4.77,4.4-9-.33-4.48-4.35-8-5.42-9.26A18.72,18.72,0,0,0,242.05,68.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M312.65,416.44l-66.06,4.2a31.6,31.6,0,0,1-32.74-24.16C187.17,285.42,143.21,97.11,143.67,96.83c2.26-1.36,5.56-1.62,8.16-3.66,1.17-.92,25,18.58,46,20.16,13.64,1,32.36-3.76,42.67-11.66,6.31-5.18,9.36-13.35,12.58-20.85l44.86,23.79,2.05,1.08h.09l.27.14v1.67c-.61,1.76-1.18,3.56-1.71,5.42-8.68,30.12-7.17,70.74-.81,75.71a17.62,17.62,0,0,0,7.45,3.67,46.75,46.75,0,0,0,5.25.76h.26l1.39.12c-.58,2.23-1.14,4.49-1.66,6.79q-1.86,8.37-3.15,17.37c-2.48,17.22-3.59,36.29-4.36,57.52C300.83,334.67,303.48,382.13,312.65,416.44Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 194.78,
    cy: 270.79,
    r: 5.66
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.03,
    cy: 325.9,
    r: 5.66
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.54,
    cy: 106.2,
    r: 5.66
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.38,
    cy: 157.84,
    r: 5.66
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.46,
    cy: 218.45,
    r: 5.66
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 241.9,
    y: 313,
    width: 56.76,
    height: 4.41
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-202",
    x1: 261.22,
    y1: 232.28,
    x2: 259.33,
    y2: 313
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 110.62,
    y: 313.82,
    width: 56.76,
    height: 4.41
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-202",
    x1: 148.05,
    y1: 233.1,
    x2: 149.95,
    y2: 313.82
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "275.38 173.83 232.95 173.83 236.25 163.5 278.68 163.5 275.38 173.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle601);
export default __webpack_public_path__ + "static/media/STYLE 6-01.33c1a0a94b1f29a19c49a0dd1fec0983.svg";
export { ForwardRef as ReactComponent };